import { useState, useCallback, useEffect } from 'react';
//import { FormFieldProps } from 'Components';
import { PartMaster } from 'Models';
import { PartMasterService } from 'Services';
import { Autocomplete, FormFieldProps } from '@cae/component-library';
import { AutocompleteChangeReason, AutocompleteInputChangeReason, TextField } from '@mui/material';

export const CustomField: React.FC<FormFieldProps> = ({ formField, formFieldId, error, onChange }) => {
    const [partMasters, setPartMasters] = useState<PartMaster[]>([]);
    const [itemNumber, setItemNumber] = useState<PartMaster>(new PartMaster({ itemNumber: formField.value }));

    // Set form initial value
    useEffect(() => {
        setItemNumber(new PartMaster({ itemNumber: formField.value }));

        if (formField.value) {
            PartMasterService.GetPartMasterStartingWith(formField.value)
                .subscribe({
                    next: partMasters => setPartMasters(partMasters)
                });
        }
    }, [formField])

    // Set selected partmaster
    const handleOnChange = useCallback((value: string | PartMaster | null, reason: AutocompleteChangeReason) => {
        if (reason === "selectOption") {
            if (onChange && value && "string" !== typeof value) {
                onChange(value.itemNumber, formField);
            }
        } else if (reason === "clear") {
            setPartMasters([]);
        }
    }, [onChange, formField]);

    // Update partmaster list
    const handleOnInputChange = useCallback((value: string, reason: AutocompleteInputChangeReason) => {
        setItemNumber(new PartMaster({ itemNumber: value }));
        if (value && reason === "input") {
            PartMasterService.GetPartMasterStartingWith(value)
                .subscribe({
                    next: partMasters => {
                        setPartMasters(partMasters);
                        if (onChange && partMasters.length === 1 && value === partMasters[0].itemNumber) {
                            onChange(value, formField);
                        }
                    }
                });
        }
    }, [formField, onChange]);

    return (
        <Autocomplete
            value={itemNumber}
            fullWidth
            options={partMasters}
            getOptionLabel={(partMaster) => partMaster.itemNumber}
            renderInput={(props) => <TextField { ...props } variant="outlined" margin="dense" helperText={error ? error.reasons[0] : ''} error={error ? true : false} />}
            onChange={(event, value, reason) => handleOnChange(value, reason)}
            onInputChange={(event, value, reason) => handleOnInputChange(value, reason)}
        />
    )
}